import React, { Fragment, useEffect } from 'react';
import { Button, Col, Form, message, Row } from 'antd';
import { useHistory, useParams } from 'react-router-dom';
import * as CommonService from '../../../services/CommonService';
import { SUPPLIER } from '../../../services/endpoint';
import SupplierDetail from './components/SupplierDetail';

export default (props) => {

  const history = useHistory();

  const [supplier, setSupplier] = React.useState({});

  const { id } = useParams();

  useEffect(() => {
    window.setLoading(true);
    CommonService.findById(SUPPLIER, id).then(res => {
      if (res?.status === 200) {
        setSupplier(res.data || {});
      }
    }).catch(err => {
      message.error(err?.data?.message || 'Có lỗi xảy ra');
    }).finally(() => window.setLoading(false));
  }, []);

  return (
    <Fragment>
      <Form layout={'vertical'}>
        <Row gutter={12}>
          <SupplierDetail supplier={supplier} />
        </Row>
        <Col style={{ textAlign: 'right', marginTop: 10 }}>
          <Button style={{ marginRight: '5px' }} onClick={() => history.push('/supplier')}>Thoát</Button>
        </Col>
      </Form>
    </Fragment>
  );
};

